export default "__VITE_ASSET__DxnA1fl8__"